import { StoreModule } from '@ngrx/store';
import { ProfileFeatureKey } from './profile-feature-key';
import { profileReducer } from './profile.reducer';

export * from './profile-feature-key';
export * from './profile.actions';
export * from './profile.effects';
export * from './profile.reducer';
export * from './profile.selectors';

export const ProfileStoreModule = StoreModule.forFeature(
  ProfileFeatureKey,
  profileReducer
);
